import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import DEFAULT_OPERATIONS from "./cmsPage.gql";

export const useCmsPage = (props) => {
  const { identifier } = props;

  const { getCMSPageQuery } = DEFAULT_OPERATIONS;

  const { loading, error, data } = useQuery(getCMSPageQuery, {
    variables: {
      identifier: identifier,
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    context: { fetchOptions: { method: "GET" } },
  });

  const shouldShowLoadingIndicator = loading && !data;

  const cmsPage = data ? data.cmsPage : null;
  const rootCategoryId = data ? data.storeConfig.root_category_id : null;

  const hasContent = useMemo(() => {
    return (
      cmsPage &&
      cmsPage.content &&
      cmsPage.content.length > 0 &&
      !cmsPage.content.includes("CMS homepage content goes here.")
    );
  }, [cmsPage]);

  return {
    cmsPage,
    error,
    hasContent,
    rootCategoryId,
    shouldShowLoadingIndicator,
  };
};
